import React from 'react';
import './ShortClientCarousel.css';

import logoA from '../../assets/images/Airports_Authority_of_India_logo.png';
import logoB from '../../assets/images/Jindal_logo_Revised.png';
import logoC from '../../assets/images/Agilus_Diagnostics_Logo.png';
import logoD from '../../assets/images/Steel_Authority_of_India_logo.png';
import logoE from '../../assets/images/JSW_Group_logo.png';
import logoF from '../../assets/images/Adani_logo_2012.png';
import logoG from '../../assets/images/aarati_steel_logo.png';
import logoH from '../../assets/images/Sify.png';
import logoI from '../../assets/images/Airports_Authority_of_India_logo.png';
import logoJ from '../../assets/images/Jindal_logo_Revised.png';
import logoK from '../../assets/images/Agilus_Diagnostics_Logo.png';
import logoL from '../../assets/images/Steel_Authority_of_India_logo.png';
import logoM from '../../assets/images/JSW_Group_logo.png';
import logoN from '../../assets/images/Adani_logo_2012.png';
import logoO from '../../assets/images/aarati_steel_logo.png';
import logoP from '../../assets/images/Sify.png';
// import logoI from '../../assets/images/logo_sarsindialiaison.jpg';
// import logoJ from '../../assets/images/logo_sarsindialiaison.jpg';

export default function ShortClientCarousel() {
  const clients = [
    { name: 'Client A', logo: logoA },
    { name: 'Client B', logo: logoB },
    { name: 'Client C', logo: logoC },
    { name: 'Client D', logo: logoD },
    { name: 'Client E', logo: logoE },
    { name: 'Client F', logo: logoF },
    { name: 'Client G', logo: logoG },
    { name: 'Client H', logo: logoH },
    { name: 'Client I', logo: logoI },
    { name: 'Client J', logo: logoJ },
    { name: 'Client K', logo: logoK },
    { name: 'Client L', logo: logoL },
    { name: 'Client M', logo: logoM },
    { name: 'Client N', logo: logoN },
    { name: 'Client O', logo: logoO },
    { name: 'Client P', logo: logoP },
  ];

  return (
    <section className="client-carousel">
      <div className="container">
        <h2 className="section-title-11">Our Esteemed Clients</h2>
        <div className="carousel-container">
          <div className="carousel">
            {clients.map((client, index) => (
              <div key={index} className="carousel-item">
                <img src={client.logo} alt={client.name} className="client-logo" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
